import React, { useState } from 'react';
import { IProject } from 'src/typings/complexes';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { ButtonApp } from 'src/components/Button';
import { translations } from 'src/constants/translations';
import { patchCreatioProject, PostCreatioProject, postCreatioProject } from 'src/api';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import * as yup from 'yup';
import { useGetAuthData } from 'src/hooks';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const schema = yup.object().shape({
  oauth2Enpoint: yup.string(),
  oauth2ClientId: yup.string(),
  oauth2ClientSecret: yup.string(),
});

export const CreatioOauth: React.FC<{project: IProject | null}> = ({
  project,
}) => {
  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });
  const { getJWT } = useGetAuthData();
  const jwt = getJWT();
  const [error, setError] = useState('');
  const handleClose = () => {
    setError('');
  };
  const onSubmit = async (data: PostCreatioProject) => {
    let res;
    const reqData = { ...data };
    if (project?.id) {
      res = await patchCreatioProject(jwt, String(project.id), reqData);
    } else {
      res = await postCreatioProject(jwt, reqData);
    }
    if (!res.ok) {
      setError(res.data['hydra:description']);
    }
  };
  return (
    <Box>
      <Snackbar open={!!error} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {error}
        </Alert>
      </Snackbar>
      <Box mb={4} fontSize="24px" fontWeight={600}>
        OAuth
      </Box>
      <Box fontSize="14px">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box mb={4} display="flex" alignItems="center">
            <Box width="260px" mr={3}>
              Domain
            </Box>
            <Box width="260px">
              <TextField
                id="oauth2Enpoint"
                size="small"
                variant="outlined"
                name="oauth2Enpoint"
                inputRef={register}
                defaultValue={project && (project.oauth2Enpoint)}
              />
            </Box>
          </Box>
          <Box mb={4} display="flex" alignItems="center">
            <Box width="260px" mr={3}>
              Client ID
            </Box>
            <Box width="260px">
              <TextField
                id="oauth2ClientId"
                size="small"
                variant="outlined"
                name="oauth2ClientId"
                inputRef={register}
                defaultValue={project && (project.oauth2ClientId)}
              />
            </Box>
          </Box>
          <Box mb={4} display="flex" alignItems="center">
            <Box width="260px" mr={3}>
              Client Secret Key
            </Box>
            <Box width="260px">
              <TextField
                id="oauth2ClientSecret"
                size="small"
                variant="outlined"
                name="oauth2ClientSecret"
                inputRef={register}
                defaultValue={project && (project.oauth2ClientSecret)}
              />
            </Box>
          </Box>
          <Box width="260px">
            <ButtonApp
              text={translations.saveChanges}
              color="primary"
              variant="contained"
              type="submit"
              size="small"
              disabled={!formState.isValid}
            />
          </Box>
        </form>
      </Box>
    </Box>
  );
};
